import DiscountService from "@/store/services/discount.service";
import PlanService from "@/store/services/plan.service"
import GekkoProductService from "@/store/services/gekkoproduct.service"
import BillingSettingService from "@/store/services/billingsetting.service"

export default {
  namespaced: true,
  state: {
    subscription: {},
    products: [],
    activePlan: null,
    upcomingPlan: null,
    upaidPlan: null,
    minTeamSize: 0,
    teamSize: 0,
    currentCycle: null,
    activeDiscount: [],
    billingSettings: null,
    paymentDetails: null,
    nextPayment: null
  },
  getters: {
    getSubscription: state => state.subscription,
    getDiscount: state => state.activeDiscount,
    getProducts: state => state.products,
    getProductByType: state => type => state.products.find(item => item.type === type),

    getActivePlan: state => state.activePlan,

    getMinTeamSize: state => state.minTeamSize,
    getTeamSize: state => state.teamSize,

    getBillingSettings: state => state.billingSettings,
    getPaymentDetails: state => state.paymentDetails,

    getNextPayment: state => state.nextPayment
  },
  mutations: {
    setSubscription (state, subscription) {
      state.subscription = subscription;
    },
    SET_ACTIVE_PLAN (state, plan) {
      state.activePlan = plan
    },
    SET_MIN_TEAM_SIZE (state, size) {
      state.minTeamSize = size
    },
    SET_TEAM_SIZE (state, size) {
      state.teamSize = size
    },
    SET_ACTIVE_DISCOUNT (state, discount) {
      state.activeDiscount = discount
    },
    SET_PRODUCTS (state, products) {
      state.products = products
    },
    SET_BILLING_SETTINGS (state, settings) {
      state.billingSettings = settings
    },
    SET_PAYMENT_DETAILS (state, data) {
      state.paymentDetails = data
    },
    SET_NEXT_PAYMENT (state, data) {
      state.nextPayment = data
    }
  },
  actions: {
    loadSubscriptionsMainData ({ dispatch }) {
      return Promise.all([
        dispatch('loadProducts'),
        dispatch('loadDiscounts'),
        dispatch('loadBillingSettings'),
        dispatch('loadPaymentMethods'),
        dispatch('loadPlans')
      ])
    },
    loadProducts ({ commit }) {
      return GekkoProductService.list().then((response) => {
        for(var i=0;i<response.data.length;i++){
          response.data[i].cost = Number(response.data[i].cost);
        }
        commit('SET_PRODUCTS', response.data)
      })
    },
    loadNextPayment ({ commit }, pk) {
      return PlanService.getNextPayment(pk).then((response) => {
        commit('SET_NEXT_PAYMENT', response.data)
      })
    },
    loadBillingSettings ({ commit }) {
      return BillingSettingService.retrieveCurrent().then((response) => {
        commit('SET_BILLING_SETTINGS', response.data)
      })
    },
    loadPaymentMethods ({ commit }) {
      return BillingSettingService.getPaymentMethods().then((response) => {
        commit('SET_PAYMENT_DETAILS', response.data)
      })
    },
    loadPlans ({ commit, dispatch, getters }) {
      return PlanService.list({ extended: true }).then((response) => {

        const planList = response.data
        let team_size = 0

        planList.forEach((plan) => {
          switch (plan.status) {
            case 'active':
            case 'grace':
              commit('SET_ACTIVE_PLAN', plan)
              team_size = plan.team_size
              break;
          }
        })

        commit('SET_TEAM_SIZE', team_size)
        commit('SET_MIN_TEAM_SIZE', team_size)

        if (getters.getActivePlan) {
          dispatch('loadNextPayment', getters.getActivePlan.id)
        }
      })
    },
    loadDiscounts ({ commit }) {
      return DiscountService.list().then((response) => {
        let subscriptionDiscount
        if (response.data.length > 0) {
          // the highest priority will always be the first element in the array
          subscriptionDiscount = response.data[0]
        } else {
          // FALLBACK if not subscription discounts are found, hardcode the yearly subscription
          subscriptionDiscount = {
            amount: '15.00',
            short_line_description: this.getters.getRoot.$gettext('Yearly discount (15%)')
          }
        }
        
        let discountTriggerAmount
        if (subscriptionDiscount.benefit_type === 'amount') {
          discountTriggerAmount = '€' + subscriptionDiscount.amount
        } else {
          discountTriggerAmount = parseInt(subscriptionDiscount.amount) + '%'
        }
        subscriptionDiscount.triggerText = discountTriggerAmount + ' ' + this.getters.getRoot.$gettext('off!')
        subscriptionDiscount.triggerAmount = discountTriggerAmount
        
        commit('SET_ACTIVE_DISCOUNT', subscriptionDiscount)
      })
    },
  }
};